import { createModalController } from '../shared/modal-controller';

createModalController({
    popupSelector: '.StudiesModal',
    modalInnerSelector: '.StudiesModal__inner',
    openTriggerSelector: '#open-studies-modal',
    closeTriggerSelector: '.StudiesModal__close',
    initialFocusSelector: '.StudiesModal__close',
    lockScroll: true,
});
